// extracted by mini-css-extract-plugin
export var closeButton = "_cl-1";
export var closeX = "_cl-3";
export var container = "_cl-0";
export var image = "_cl-2";